module.exports = __webpack_public_path__ + "img/hanzi.3d97386b.png";